import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import Select from 'react-select';
import { RiRefreshLine } from "react-icons/ri";
import { FaSave, FaChevronLeft } from "react-icons/fa";
import LeaseApiService from '../../services/apiService';
import { IoSearch } from "react-icons/io5";
import moment from 'moment';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import CheckboxSetFilter from '../gridFilter/checkboxSetFilter';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from "react-spinners";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { useTranslation } from 'react-i18next';
const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL

const InstallmentInvoice = ({ onClose, onSaved } = {}) => {
    const { t } = useTranslation(['installmentInvoice', 'common']);
    const apiService = new LeaseApiService();
    const [loading, setloader] = useState(false);
    const [propertylist, setPropertyList] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [leasingAgent, setLeasingAgent] = useState([]);
    const [leaseList, setleaseList] = useState([]);
    const [typeList, setType] = useState([]);
    const { currencyPrecision } = useCurrency();
    const [periodFrom, setPeriodFrom] = useState("");
    const [periodTo, setPeriodTo] = useState("");
    const [transectionDate, settransectionDate] = useState("");
    const [leaseTerm, setLeaseTerm] = useState([]);
    const [groupId, setGroupId] = useState(false);
    const [totalRent, setTotalRent] = useState();
    const [totalVat, setTotalVat] = useState();
    const [totalAmount, setTotalAmount] = useState();
    const navigate = useNavigate();
    // const { encode, decode } = require('url-encode-decode')
    // let url = decode('%2BZhDmciUREwE8CkJMo3bwQ%3D%3D&_db=wCKZqDR')
    const [formData, setFormData] = useState({
        itemNo: { label: 'Select ItemNo', value: 'All' },
        ItemDescription: { label: 'Select Item', value: 'All' },
        email: "",
        property: [{ label: 'Select Property', value: 'Select Property' }],
        unit: [{ label: 'Select Unit', value: 'Select Unit' }],
        type: [{ label: 'Select Type', value: 'Select Type' }],
        tanent: [{ label: 'Select Tenant', value: 'Select Tenant' }],
        leaseNo: [{ label: 'Select Lease No', value: 'Select Lease No' }],
    });
    useEffect(() => {
        getUserList()
    }, []);
    useEffect(() => {
        const today = new Date();
        const nextMonth = new Date(today);
        nextMonth.setMonth(today.getMonth() + 1);
        nextMonth.setDate(nextMonth.getDate() + 1);
        const formattedToday = today.toISOString().split("T")[0];
        const formattedNextYear = nextMonth.toISOString().split("T")[0];

        setPeriodFrom(formattedToday);
        setPeriodTo(formattedNextYear);
        settransectionDate(formattedToday)
    }, []);

    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // month is 0-based
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    const handlePeriodFromChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodFrom(formattedDate);
    }
    const handlePeriodToChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodTo(formattedDate);
    }
    const handleTransDate = ({ name, value }) => {
        const formattedDate = formatDate(value);
        settransectionDate(formattedDate);
    }
    const getUserList = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LIISerPropertyName,LIICustomerName,LIISerUnitTypeDesc,LIISerLeaseNo');
            const customerRes = await apiService.getApiParamater('GET_INSTALL_INVOICE_DROP', `?${params.toString()}`);
            setPropertyList([{ value: 'All', text: 'All' }, ...customerRes?.data?.dropdowns?.LIISerPropertyName]);
            setLeasingAgent([{ value: 'All', text: 'All' }, ...customerRes?.data?.dropdowns?.LIICustomerName]);
            setleaseList([{ value: 'All', text: 'All' }, ...customerRes?.data?.dropdowns?.LIISerLeaseNo]);
            setType([{ value: 'All', text: 'All' }, ...customerRes?.data?.dropdowns?.LIISerUnitTypeDesc]);
        } catch (error) {
            console.error('Error fetching data:', error?.customerRes?.data?.message);
        }
    }
    const handlePropertyChange = async (selectedOption) => {
        setFormData({
            ...formData,
            property: selectedOption,
        });
        if (selectedOption?.value === "All") {
            return
        }
        const Invoice = new URLSearchParams();
        Invoice.append('DropdownFor', 'LIISerUnitsByPropId');
        Invoice.append('CascadValue', selectedOption?.value);
        const Invoiceres = await apiService.getApiParamater('GET_INSTALL_INVOICE_CASCAD', `?${Invoice.toString()}`);
        setUnitList(Invoiceres?.data?.items)

        const Customer = new URLSearchParams();
        Customer.append('DropdownFor', 'LIISerTenantsByPropId');
        Customer.append('CascadValue', selectedOption?.value);
        const resCustomer = await apiService.getApiParamater('GET_INSTALL_INVOICE_CASCAD', `?${Customer.toString()}`);
        setLeasingAgent(resCustomer?.data?.items);

        const params = new URLSearchParams();
        params.append('DropdownFor', 'LIISerLeaseNosByPropId');
        params.append('CascadValue', selectedOption?.value);
        const res = await apiService.getApiParamater('GET_INSTALL_INVOICE_CASCAD', `?${params.toString()}`);
        setleaseList(res?.data?.items);

    }
    const handleClearFilters = () => {
        setFormData({
            itemNo: { label: 'Select ItemNo', value: 'All' },
            ItemDescription: { label: 'Select Item', value: 'All' },
            email: "",
            property: [{ label: 'Select Property', value: 'Select Property' }],
            unit: [{ label: 'Select Unit', value: 'Select Unit' }],
            type: [{ label: 'Select Type', value: 'Select Type' }],
            tanent: [{ label: 'Select Tenant', value: 'Select Tenant' }],
            leaseNo: [{ label: 'Select Lease No', value: 'Select Lease No' }],
        });
        setLeaseTerm([]);
        setGroupId(false)
        setUnitList([])
        setTotalAmount(0)
        setTotalVat(0)
        setTotalRent(0)
    }
    const handleUnitChange = async (selectedOption) => {
        setFormData({
            ...formData,
            unit: selectedOption,
        });
    }
    const handleLeaseNo = async (selectedOption) => {
        setFormData({
            ...formData,
            leaseNo: selectedOption,
        });
    }
    const handleCustomer = async (selectedOption) => {
        setFormData({
            ...formData,
            tanent: selectedOption,
        });
    }
    const handleSubCategoryChange = async (selectedOption) => {
        setFormData({
            ...formData,
            type: selectedOption,
        });
    }
    const handleSearch = async () => {
        const Invoice = new URLSearchParams();
        Invoice.append('Action', 'GetLIIReceivables');
        Invoice.append('TenantNo', formData?.tanent?.value || 'All');
        Invoice.append('PropertyNo', formData?.property?.value || 'All');
        Invoice.append('UnitType', formData?.type?.label || 'All');
        Invoice.append('UnitNo', formData?.unit?.label || 'All');
        Invoice.append('LeaseNo', formData?.leaseNo?.label || 'All');
        Invoice.append('FromDate', periodFrom);
        Invoice.append('ToDate', periodTo);
        Invoice.append('ShowOther', groupId);

        const Invoiceres = await apiService.getApiParamater('GET_INSTALL_INVOICE_COMMON', `?${Invoice.toString()}`);
        if (Invoiceres?.data?.result?.data?.length === 0) {
            toast.error(t('common:noRecordFound'))
            setLeaseTerm([])
             setTotalAmount(0)
            setTotalVat(0)
            setTotalRent(0)
        } else {
            setLeaseTerm(Invoiceres?.data?.result?.data)
            let term = Invoiceres?.data?.result?.data
            const totalRent = term?.reduce((sum, row) => sum + (parseFloat(row?.Amount) || 0), 0);
            const totalVat = term?.reduce((sum, row) => sum + (parseFloat(row?.VAT) || 0), 0);
            const totalAmount = term?.reduce((sum, row) => sum + (parseFloat(row?.Total) || 0), 0);
            setTotalAmount(totalAmount)
            setTotalVat(totalVat)
            setTotalRent(totalRent)
        }
    }
    const handleActiveSelection = (e) => {
        setGroupId(e);
    }
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    }
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    }
    const onRowSelected = (event) => {
        const api = event.api;
        const isSelected = event.node.isSelected();
        const leaseNo = event.data.LeaseNo;

        if (isSelected) {
            // Select all rows with the same LeaseNo
            const sameLeaseRows = [];
            api.forEachNode((node) => {
                if (node.data.LeaseNo === leaseNo) {
                    node.setSelected(true); // This will trigger onRowSelected again for other rows
                    sameLeaseRows.push(node.data);
                }
            });

            // Update state: add selected rows (avoid duplicates)
            setSelectedRows((prev) => {
                const existingIds = new Set(prev.map(r => r.PSDId)); // use PSDId or your unique key
                return [...prev, ...sameLeaseRows.filter(r => !existingIds.has(r.PSDId))];
            });

        } else {
            // Just unselect this one row only (do not unselect others with same LeaseNo)
            const psdId = event.data.PSDId; // or PSMId if that’s the unique key
            setSelectedRows((prev) => prev.filter(r => r.PSDId !== psdId));
        }
    }
    const handleSave = async () => {
        try {
            setloader(true);
            if (!transectionDate) {
                toast.warning(t('installmentInvoice:pleaseSelectTransactionDate'));
                setloader(false);
                return;
            }

            const currentDatetimeUTC = new Date().toISOString();

            if (selectedRows.length === 0) {
                toast.warning(t('installmentInvoice:pleaseSelectLeaseNo'));
                setloader(false);
                return;
            }

            const Invoice = new URLSearchParams();
            Invoice.append('Action', 'chkPostingDateInFinYear');
            Invoice.append('FromDate', transectionDate);

            const Invoiceres = await apiService.getApiParamater('GET_INSTALL_INVOICE_COMMON', `?${Invoice.toString()}`);

            let result = Invoiceres?.data?.result?.data
            if (result?.length === 0) {
                toast.warning(t('installmentInvoice:postingDateOutsideFinYear'))
                setloader(false);
                return
            } else if (result?.length > 0) {
                const accountDetailsList = selectedRows?.map(item => {
                    let Rent = item?.Rent?.toFixed(currencyPrecision?.decimalNumbers)
                    let Amount = item?.Amount?.toFixed(currencyPrecision?.decimalNumbers)
                    let Total = item?.Total?.toFixed(currencyPrecision?.decimalNumbers)
                    return {
                        leaseNo: item?.LeaseNo,
                        propertyNo: item?.PropertyNo,
                        propertyName: item?.PropertyName,
                        unitNo: item?.UnitNo,
                        tenantNo: item?.TenantNo,
                        tenantName: item?.TenantName,
                        tax: item?.Tax,
                        rent: parseFloat(Rent),
                        amount: parseFloat(Amount),
                        vat: item?.VAT,
                        total: parseFloat(Total),
                        leaseStart: item?.LeaseStart,
                        leaseEnd: item?.LeaseEnd,
                        selected: true,
                        psmId: item?.PSMId || 0,
                        groupId: item?.GroupId,
                        status: item?.Status,
                        taxCode: item?.TaxCode,
                        taxInclusive: item?.TaxInclusive,
                        vatPercent: item?.VATPercent,
                        narration: item?.Narration,
                        vatAcCode: item?.VATAcCode,
                        vatAcName: item?.VATAcName,
                        psdId: item?.PSDId,
                        liRecordId: item?.LIRecordId || 0,
                        tranId: item?.TranId,
                        isInvoiceGenerated: item?.IsInvoiceGenerated,
                        category: item?.Category,
                        invoiceNo: item?.InvoiceNo,
                        invoiceDate: item?.InvoiceDate,
                        dueDate: item?.DueDate,
                        postingDate: item?.PostingDate,
                        isApproved: item?.IsApproved,
                        isOther: item?.IsOther,
                        isSD: item?.IsSD,
                        description: item?.Description,
                        received: item?.Received,
                        refNo: item?.RefNo || "0",
                        isCreditNoteMade: item?.IsCreditNoteMade,
                        isChecked: true
                    }
                });
                const leaseInvoice = {
                    recordId: 0,
                    leaseNo: "0",
                    propertyNo: "0",
                    propertyName: "0",
                    unitNo: "0",
                    unitRefNo: "0",
                    tenantNo: "0",
                    tenantName: "0",
                    voucherType: "0",
                    psId: 0,
                    paymentType: "0",
                    amount: 0,
                    vatPercent: 0,
                    vat: 0,
                    stPercent: 0,
                    st: 0,
                    total: 0,
                    amountReceived: 0,
                    dueDate: currentDatetimeUTC,
                    postingDate: currentDatetimeUTC,
                    postingId: "0",
                    voucherNo: "0",
                    financialYear: "0",
                    creditAcCode: "0",
                    debitAcCode: "0",
                    tranId: 0,
                    category: "0",
                    taxCode: 0,
                    remarks: "0",
                    isApproved: true,
                    approvedDate: currentDatetimeUTC,
                    approvedBy: "0",
                    exp1: "0",
                    exp2: "0",
                    exp3: "0",
                    exp4: "0",
                    exp5: "0",
                    modifiedBy: "0",
                    modifiedOn: currentDatetimeUTC,
                    createdBy: "0",
                    createdOn: currentDatetimeUTC,
                    leaseFromDate: currentDatetimeUTC,
                    leaseToDate: currentDatetimeUTC,
                    transactionDate: currentDatetimeUTC
                };

                const body = {
                    installmentInvoiceMain: {
                        leaseInvoice: leaseInvoice,
                        accountDetailsList: accountDetailsList,
                        creditNote_PostingDate: moment(transectionDate).format("YYYY-MM-DDTHH:mm:ss")
                    },
                };
                const postRes = await apiService.post("POST_INSTALL_INVOICE", body);
                if (postRes?.data?.statusCode === 201 || postRes?.data?.statusCode === 20) {
                    toast.success(t('installmentInvoice:invoiceCreatedSuccess'));
                    let rowData = postRes?.data?.result

                    let reportData = null;
                    try {
                        const Invoice = new URLSearchParams();
                        Invoice.append('Action', 'GetVoucherNoByTranId');
                        Invoice.append('GroupId', rowData?.tranId);
                        const Invoiceres = await apiService.getApiParamater('GET_INSTALL_INVOICE_COMMON', `?${Invoice.toString()}`);
                        reportData = Invoiceres?.data?.result?.data?.[0] || null;
                    } catch (error) {
                        console.error("Error fetching invoice details for report", error);
                        reportData = null;
                    }
                    debugger
                    if (reportData) {
                        const token = localStorage.getItem("Token");
                        const DB = localStorage.getItem("DataBase")
                        if (!token) {
                            alert("Auth token is missing! Unable to proceed.");
                            setloader(false);
                            return;
                        }
                        const popupWidth = 1000;
                        const popupHeight = 600;
                        const popupLeft = (window.screen.width - popupWidth) / 2;
                        const popupTop = (window.screen.height - popupHeight) / 2;
                        const popup = window.open(
                            "",
                            "ReportPopup",
                            `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
                        );

                        if (popup) {
                            const form = document.createElement("form");
                            form.method = "POST";
                            form.action = REACT_APP_REPORTS;
                            form.target = "ReportPopup";

                            const inputs = [
                                { name: "authToken", value: token },
                                { name: "_db", value: DB },
                                { name: "RecordId", value: reportData?.TranId },
                                { name: "LeaseNo", value: reportData?.LeaseNo },
                                { name: "ReceiptNo", value: reportData?.VoucherNo },
                                { name: "reportName", value: 'INSTALLMENTINV' },
                            ];
                            inputs.forEach(({ name, value }) => {
                                const input = document.createElement("input");
                                input.type = "hidden";
                                input.name = name;
                                input.value = value;
                                form.appendChild(input);
                            });

                            document.body.appendChild(form);
                            form.submit();
                            document.body.removeChild(form);
                        }
                    }
                    setloader(false);
                    handleClearFilters()
                    if (onSaved) {
                        onSaved();
                    } else {
                        navigate("/Property/Management/Installment/Invoice/Listing");
                    }
                } else {
                    setloader(false);
                }
            }
        } catch (error) {
            setloader(false);

            console.error("Error Save Data", error);
        }
    }
    const columnDefs = [
        {
            checkboxSelection: true,
            headerCheckboxSelection: true, // Enables "select all" in header
            headerCheckboxSelectionFilteredOnly: true,
            suppressMovable: true,
            width: 50,
            pinned: 'left'
        },
        { headerName: t('installmentInvoice:columns.leaseNo'), field: 'LeaseNo', filter: CheckboxSetFilter, suppressMovable: true, width: 120, pinned: 'left' },
        { headerName: t('installmentInvoice:columns.property'), field: 'PropertyName', filter: CheckboxSetFilter, suppressMovable: true, width: 250 },
        { headerName: t('installmentInvoice:columns.unitNo'), field: 'UnitNo', filter: CheckboxSetFilter, suppressMovable: true, width: 95 },
        { headerName: t('installmentInvoice:columns.tenantNo'), field: 'TenantNo', filter: CheckboxSetFilter, suppressMovable: true, width: 120 },
        {
            headerName: t('installmentInvoice:columns.rent'), field: 'Rent', filter: CheckboxSetFilter, suppressMovable: true, width: 100,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers)
        },
        { headerName: t('installmentInvoice:columns.description'), field: 'Description', filter: CheckboxSetFilter, suppressMovable: true, width: 340 },
        {
            headerName: t('installmentInvoice:columns.dueDate'), field: "DueDate", filter: CheckboxSetFilter,
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 120
        },
        { headerName: t('installmentInvoice:columns.tax'), field: 'Tax', filter: CheckboxSetFilter, suppressMovable: true, width: 140 },
        {
            headerName: t('installmentInvoice:columns.vat'), field: 'VAT', filter: CheckboxSetFilter, suppressMovable: true, width: 100,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers)
        },
        {
            headerName: t('installmentInvoice:columns.amount'), field: 'Amount', filter: CheckboxSetFilter, suppressMovable: true, width: 100,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers)
        },
        {
            headerName: t('installmentInvoice:columns.total'), field: 'Total', filter: CheckboxSetFilter, suppressMovable: true, width: 100,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers)
        },
    ]

    return (
        <div className='p-3'>
            <div className='d-flex justify-content-between p-2 gridBg mt-2' style={{ borderRadius: "8px 8px 0px 0px " }}>
                <div className='mainInvHead center' >{t('installmentInvoice:generateTitle')}</div>
            </div>
            <div className='gridBg m-0 row' style={{ borderRadius: "0px 0px 16px 16px" }}>
                <div className='col-9 form-group' style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '10px' }}>
                    <div className='d-flex'>
                        <Select
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            className="p-0 w-100"
                            value={formData.property}
                            options={propertylist?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                            onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                        />
                    </div>
                    <div className='d-flex'>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={formData.tanent}
                            options={leasingAgent?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                            onChange={(selectedOption) => handleCustomer(selectedOption)}
                        />
                    </div>
                    <div className='d-flex gap-3'>
                        <label className='form-label mt-2'>{t('common:fromDate')}</label>
                        <DatePicker
                            todayButton="Today"
                            selected={periodFrom}
                            onChange={(date) => handlePeriodFromChange({ name: 'leaseDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className='d-flex'>
                        <Select
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            className="p-0 w-100"
                            value={formData.unit}
                            options={unitList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                            onChange={(selectedOption) => handleUnitChange(selectedOption)}
                        />
                    </div>
                    <div className='d-flex'>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={formData?.leaseNo}
                            onChange={(selectedOption) => handleLeaseNo(selectedOption)}
                            options={leaseList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                        />
                    </div>
                    <div className='d-flex gap-3'>
                        <label className='form-label mt-2'>{t('common:toDate')}</label>
                        <DatePicker
                            todayButton="Today"
                            selected={periodTo}
                            onChange={(date) => handlePeriodToChange({ name: 'toDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className='d-flex'>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={formData?.type}
                            onChange={(selectedOption) => handleSubCategoryChange(selectedOption)}
                            options={typeList?.map((SubCatOpt) => ({ value: SubCatOpt?.value, label: SubCatOpt?.text }))}
                        />
                    </div>
                    <div className='d-flex gap-3'>
                        <label className='form-label mt-2'>{t('installmentInvoice:transactionDate')}</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionDate}
                            onChange={(date) => handleTransDate({ name: 'transectionDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className='d-flex'  >
                        <div className='d-flex mt-2 gap-4 '>
                            <input className="form-check-input"
                                type="checkbox"
                                id="groupId" style={{ width: "20px", height: "20px" }}
                                name="groupId"
                                checked={groupId}
                                onChange={(e) => handleActiveSelection(e.target.checked)}
                            />
                            <label className='form-label mt-2' >{t('installmentInvoice:includeOtherCharges')}</label>
                        </div>
                    </div>
                </div>
                <div className='col-3 '>
                    <div onClick={() => handleSearch()} className='mainbtnGry flex-end mt-2 gap-2'>
                        <IoSearch color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>{t('common:search')}</div>
                    </div>
                    <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end my-2 gap-2'>
                        <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>{t('common:reset')}</div>
                    </div>
                    {onClose && (
                        <div onClick={() => onClose()} className='mainbtnRed flex-end my-2 gap-2'>
                            <div className='center'>{t('common:cancel')}</div>
                        </div>
                    )}
                    {loading === true ? (
                        <div className="mainbtn flex-end gap-2">
                            <ClipLoader color="#ffffff" className="mt-1" size={25} />
                        </div>
                    ) : (
                        <div className="mainbtn flex-end gap-2" onClick={handleSave}>
                            <FaSave color="#fff" className="center mt-2 mx-2" />
                            <div className="center">{t('common:save')}</div>
                        </div>
                    )}
                </div>
            </div>

            <div className='gridshad mt-1'>
                <div className='table-container' style={{ overflowX: 'auto', height: "490px" }}>
                    <div className="ag-theme-quartz" style={{ height: 650 }}>
                        <AgGridReact
                            rowData={leaseTerm}
                            columnDefs={columnDefs}
                            rowSelection="multiple"
                            onRowSelected={onRowSelected} // ✅ Changed here
                            suppressRowClickSelection={true}
                            // onSelectionChanged={onSelectionChanged}
                            getRowStyle={(params) => {
                                if (params.node.rowIndex % 2 === 0) {
                                    return { background: '#F0EDF5' };
                                } else {
                                    return { background: '#fff' };
                                }
                            }}
                        />
                    </div>
                </div>
                <div className='d-flex justify-content-between boxs'>
                    <div className='d-flex gap-2'>
                        <div className="totalhead center">{t('installmentInvoice:leaseCount')}</div>
                        <div className='field'>{`${leaseTerm?.length || 0}` || "---"}</div>
                    </div>
                    <div className='d-flex gap-2'>
                        <div className="totalhead center">{t('installmentInvoice:totalRent')} </div>
                        <div className='field'>{totalRent?.toFixed(currencyPrecision?.decimalNumbers) || "---"}</div>
                    </div>
                    <div className='d-flex gap-2'>
                        <div className="totalhead center">{t('installmentInvoice:totalVat')}</div>
                        <div className='field'>{totalVat?.toFixed(currencyPrecision?.decimalNumbers) || "---"}</div>
                    </div>
                    <div className='d-flex gap-2'>
                        <div className="totalhead center">{t('installmentInvoice:totalAmount')}</div>
                        <div className='field'>{totalAmount?.toFixed(currencyPrecision?.decimalNumbers) || "---"}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default InstallmentInvoice;